/**
 * React Error Boundary - Catches unhandled component errors
 * Logs errors and shows fallback UI instead of white screen
 */

import React from 'react';
import errorLogger from '../../utils/errorLogger';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    errorLogger.logError(error, {
      type: 'REACT_ERROR_BOUNDARY',
      componentStack: errorInfo.componentStack,
      errorBoundary: this.props.name || 'Unknown'
    });
  }

  render() {
    if (this.state.hasError) {
      // Custom fallback UI
      if (this.props.fallback) {
        return this.props.fallback;
      }

      // Default fallback UI
      return (
        <div className="error-boundary" style={{
          padding: '20px',
          textAlign: 'center',
          backgroundColor: '#fff3cd',
          border: '1px solid #ffeaa7',
          borderRadius: '4px',
          margin: '20px'
        }}>
          <h3>⚠️ Something went wrong</h3>
          <p>We've logged this error and our team will look into it.</p>
          <button 
            onClick={() => window.location.reload()}
            style={{
              padding: '8px 16px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Refresh Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 